const REGEX_TO_CHECK_XDSL_SUBSCRIPTION_TYPE = /^[xDSL](?:\/?[x_dsl])*$/gm;

export default REGEX_TO_CHECK_XDSL_SUBSCRIPTION_TYPE;
